import React from 'react';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//select
import SelectSearch from 'react-select-search';
import 'src/asset/scss/plugin/select.scss';
//styles
import styles from 'src/asset/scss/styles/userMembers.module.scss';

export default function Search(props) {
    //searchData
    const searchRef = props.search;
    //selectOption
    const option = [{name:'--옵션선택--', value:'ALL'}, {name:'회원명', value:1}, {name:'업체명', value:2}];
    const today = new Date().toISOString().slice(0, 10);//오늘날짜셋팅
    /* ==================== 검색이벤트 ==================== */
    const handleKeydown = (e) => {
        if(e.key === 'Enter') {
            props.onSearch(0, 3);
        }
    };
    const onChangeHandler = (e) => {
        const value = e.target.value;
        if(value.length > 0) { return; }
        props.onSearch(0, 3);
    }
    /* ==================== 검색이벤트 ==================== */

    return ( 
        <div className={styles.searchArea}>
            <div className="selectArea">
                <SelectSearch options={option} defaultValue={searchRef?.current[0]?.value === undefined ? option[0].value : searchRef?.current[0]?.value}
                    ref={el => (searchRef.current[0] = el)} onChange={el => (searchRef.current[0].value = el)}
                    placeholder="--옵션선택--" />
            </div>
            <div className={styles.searchField}>
                <input ref={el => (searchRef.current[1] = el)} 
                    onKeyDown={(e) => handleKeydown(e)} onChange={(e) => onChangeHandler(e)}
                    type="text" placeholder="결제내역을 검색 해보세요" />
                <button><FontAwesomeIcon icon="fa-light fa-magnifying-glass" /></button>
            </div>
            <div className={styles.dateField}>
                <input type="date" onChange={(e) => props.onSearch(0, 3)}
                    ref={el => (searchRef.current[2] = el)}
                    defaultValue={today}
                    max={new Date().toJSON().slice(0, 10)} />
                <span>-</span>
                <input type="date" onChange={(e) => props.onSearch(0, 3)} 
                    ref={el => (searchRef.current[3] = el)}
                    defaultValue={today}
                    max={new Date().toJSON().slice(0, 10)} />
            </div>
        </div>
    );
}